import { render, staticRenderFns } from "./omt-uppercase.vue?vue&type=template&id=28d44510&scoped=true&"
var script = {}
import style0 from "./omt-uppercase.vue?vue&type=style&index=0&id=28d44510&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28d44510",
  null
  
)

export default component.exports